module.exports = __webpack_public_path__ + "assets/img/shouye_canyinyuding.630e48c9.svg";